(function () {
  var T = {
    de: { kicker: 'Komplettiere deinen Look', title: 'Passende Produkte', note: 'Gutscheine kannst du im letzten Schritt der Bestellung einlösen.' },
    en: { kicker: 'Complete your look', title: 'Complementary products', note: 'Vouchers can be entered in the last step of the order.' },
    tr: { kicker: 'Kombini tamamla', title: 'Tamamlayıcı ürünler', note: 'İndirim kodunu siparişin son adımında girebilirsin.' }
  };
  var pageLang = document.documentElement.lang || 'de';
  var t = T[pageLang.slice(0, 2)] || T.de;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';

  function money(cents) {
    try { return new Intl.NumberFormat(pageLang, { style: 'currency', currency: currency }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2) + ' €'; }
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function card(p) {
    var img = p.featured_image || (p.images && p.images[0]) || '';
    if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=400';
    var onSale = p.compare_at_price && p.compare_at_price > p.price;
    var badge = onSale && (p.tags || []).indexOf('sale') > -1;
    var url = p.url || (root + 'products/' + p.handle);
    return '<a class="ay-card" href="' + esc(url) + '">' +
      '<div class="ay-card__img">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
      (badge ? '<span class="ay-card__badge">Deal</span>' : '') + '</div>' +
      '<div class="ay-card__vendor">' + esc(p.vendor) + '</div>' +
      '<div class="ay-card__name">' + esc(p.title) + '</div>' +
      '<div class="ay-card__price' + (badge ? ' ay-card__price--sale' : '') + '">' + money(p.price) +
      (onSale ? '<span class="ay-card__was">' + money(p.compare_at_price) + '</span>' : '') + '</div></a>';
  }
  function loadRecs(productId, intent) {
    return fetch(root + 'recommendations/products.json?product_id=' + productId + '&limit=8&intent=' + intent)
      .then(function (r) { return r.json(); })
      .then(function (d) { return (d && d.products) || []; });
  }

  function init() {
    var items = document.querySelector('cart-items');
    if (!items) return;

    var blocks = document.querySelector('#main-cart-footer .cart__blocks');
    if (blocks && !blocks.querySelector('.ay-cart-extras')) {
      var extras = document.createElement('div');
      extras.className = 'ay-cart-extras';
      var pay = document.querySelector('.footer .list-payment');
      if (pay) {
        var copy = pay.cloneNode(true);
        copy.className = 'ay-cart-pay';
        extras.appendChild(copy);
      }
      var note = document.createElement('p');
      note.className = 'ay-cart-note';
      note.textContent = t.note;
      extras.appendChild(note);
      blocks.appendChild(extras);
    }

    var box = document.createElement('div');
    box.className = 'ay-cart-recs';
    items.appendChild(box);

    fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      if (!cart.items || !cart.items.length) return;
      var inCart = cart.items.map(function (i) { return i.product_id; });
      var id = cart.items[0].product_id;
      return loadRecs(id, 'complementary')
        .then(function (list) { return list.length ? list : loadRecs(id, 'related'); })
        .then(function (list) {
          list = list.filter(function (p) { return inCart.indexOf(p.id) === -1; }).slice(0, 5);
          if (!list.length) return;
          box.innerHTML = '<p class="ay-recs__kicker">' + esc(t.kicker) + '</p>' +
            '<h3 class="ay-recs__title">' + esc(t.title) + '</h3>' +
            '<div class="ay-recs__grid">' + list.map(card).join('') + '</div>';
        });
    }).catch(function () {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();